import { useState } from 'react'

import { Typography } from 'antd'

import { RxCross2 } from 'react-icons/rx'
import { TbLoader2 } from 'react-icons/tb'
import { FaTimesCircle } from 'react-icons/fa'
import { FaCircleCheck } from 'react-icons/fa6'
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io'

import { useUpload } from '../../../context/UploadResumeContext'

export default function ActionsInProgressPanel() {
    const { open, setOpen, uploadingList } = useUpload()
    const { Text } = Typography
    const [collapsed, setCollapsed] = useState(false)

    if (!open) return null

    return (
        <div
            style={{
                position: 'fixed',
                bottom: 0,
                right: 20,
                width: 350,
                zIndex: 2000,
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                borderRadius: '6px 6px 0 0',
                overflow: 'hidden',
                transition: 'all 0.6s ease',
            }}
        >
            <div
                style={{
                    backgroundColor: '#2f3542',
                    color: '#fff',
                    padding: '10px 16px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <span style={{ fontWeight: 600 }}>
                    Actions{' '}
                    {uploadingList?.length > 0 &&
                    uploadingList
                        .filter((data) => data?.status !== 'error')
                        .every((data) => data?.status === 'done')
                        ? 'Completed'
                        : 'in Progress'}
                </span>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    {collapsed ? (
                        <IoIosArrowUp
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapsed(false)}
                        />
                    ) : (
                        <IoIosArrowDown
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapsed(true)}
                        />
                    )}
                    <RxCross2
                        size={22}
                        style={{ cursor: 'pointer' }}
                        onClick={() => setOpen(false)}
                    />
                </div>
            </div>

            <div
                style={{
                    background: '#fff',
                    maxHeight: collapsed ? '0px' : '300px',
                    overflow: 'hidden',
                    transition: 'max-height 0.4s ease',
                }}
            >
                <div style={{ overflowY: 'auto', maxHeight: '300px' }}>
                    {uploadingList.length === 0 ? (
                        <div className="p-3">
                            <Text type="secondary">No active uploads</Text>
                        </div>
                    ) : (
                        uploadingList.map((file) => (
                            <div
                                key={file.uid}
                                className="d-flex align-items-center justify-center gap-3 border-bottom p-2"
                            >
                                {file.status === 'in_progress' ? (
                                    <TbLoader2
                                        size={20}
                                        className="spin-loader-resume"
                                        color="#4f46e5"
                                    />
                                ) : file.status === 'error' ? (
                                    <FaTimesCircle color="#e74c3c" size={18} />
                                ) : (
                                    <FaCircleCheck color="#05b279" size={18} />
                                )}
                                <div>
                                    <Text strong>{file.name}</Text>
                                    <br />
                                    <Text type="secondary">
                                        {file.status === 'in_progress'
                                            ? file.step || 'In progress...'
                                            : file.status === 'error'
                                            ? 'Upload failed'
                                            : 'Uploaded successfully'}
                                    </Text>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}
